import ModalStripeOnboarding from './ModalStripeOnboarding';

export default ModalStripeOnboarding;
